<div class="modal-header">
	<h4 class="modal-title pull-left">Upload file</h4>
	<button type="button" class="close pull-right" aria-label="Close" (click)="cancel()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>

<div class="modal-body">
	<div class="center text-center">

		<div class="container" appDnd (fileDropped)="handleFileInput($event)">
			<h6>{{fileText}}</h6>
			<!-- <img src="assets/img/dnd/ic-upload-file.svg" alt=""> -->
			<h5 class="text-muted">Drag and drop file here</h5>
			<h5 class="text-muted">or</h5>
			<input type="file" #fileDropRef id="fileDropRef" [accept]="properties.allowedTypes.join()"
				(change)="handleFileInput($event.target.files)" />
			<button for="fileDropRef" class="btn btn-light">Browse file</button>
		</div>

		<small class="text-danger" *ngIf="errorMessage">{{errorMessage}}</small>
	</div>
</div>

<div class="modal-footer">
	<button type="button" class="btn btn-light" (click)="cancel()">
		Cancel
	</button>
	<am-button (onClicked)="uploadFileToActivity()" [text]="'Upload'" [isLoading]="isButtonDisabled"></am-button>
</div>